export interface Testimonial {
  initials: string
  name: string
  role: string
  location: string
  text: string
}

/**
 * Add verified MMA coach testimonials here.
 * The testimonials section stays hidden while this list is empty.
 */
export const shortTestimonials: Testimonial[] = []
